export default "__VITE_ASSET__DEq2912o__"